<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cZ6Mma/tc-custom/9780062029300.jpg?1740302873419" alt="This image is the cover for the book Island"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Island
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Gripping . . . Abbott writes evocatively of every phase in his memorable protagonist’s odyssey . . . a convincing, insightful and eminently readable tale.” —</b><i><b>Publishers Weekly</b></i></p><p>A portrait of Fred Fay follows an outwardly successful but selfish man's descent into alcoholism and failure and his slow, difficult recovery into a wholly new and meaningful life.</p><p>“Rich in character and language, this is one of those rare novels the reader hates to see come to an end.” —<i>Library Journal</i></p><p>“An often penetrating portrait of a troubled individual's desperate search for and avoidance of human intimacy.” —<i>Booklist</i></p><p>“Absorbing.” —<i>Kirkus Reviews</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Abbott
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3d1a44a8